"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHeader_styled_exports = {};
__export(GlobalHeader_styled_exports, {
  StyledAppSelectorIconContainer: () => StyledAppSelectorIconContainer,
  StyledAvatarButton: () => StyledAvatarButton,
  StyledAvatarContainer: () => StyledAvatarContainer,
  StyledBreadcrumbComponent: () => StyledBreadcrumbComponent,
  StyledBreadcrumbSeparator: () => StyledBreadcrumbSeparator,
  StyledHeader: () => StyledHeader,
  StyledLeftComponentContainer: () => StyledLeftComponentContainer,
  StyledPageNextButton: () => StyledPageNextButton,
  StyledPagePrevButton: () => StyledPagePrevButton,
  StyledPageTitle: () => StyledPageTitle,
  StyledRightComponentContainer: () => StyledRightComponentContainer,
  StyledSkipToContent: () => StyledSkipToContent,
  StyledTitleContainer: () => StyledTitleContainer,
  StyledUserToolbar: () => StyledUserToolbar
});
module.exports = __toCommonJS(GlobalHeader_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_Heading = require("../../atoms/Heading/Heading.component");
var import_Button = require("../../atoms/Button/Button.component");
var import_atoms = require("../../atoms");
var import_BaseHeader = require("./BaseHeader/BaseHeader.component");
var import_types = require("./types");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var stickyStyle = "position: sticky;";
var stickyBreakpoints = _defineProperty(_defineProperty({}, import_types.StickyControl.disabled200, "lg"), import_types.StickyControl.disabled400, "md");
function setSticky(control) {
  var stickyBreakpointValue = stickyBreakpoints[control];
  return stickyBreakpointValue ? (0, import_mixins.mediaBreakpointUp)(stickyBreakpointValue, stickyStyle) : stickyStyle;
}
var StyledHeader = (0, import_styled_components.default)(import_BaseHeader.BaseHeader).withConfig({
  displayName: "GlobalHeaderstyled__StyledHeader",
  componentId: "sc-1a29rwt-0"
})(function(_ref) {
  var theme = _ref.theme, darkMode = _ref.darkMode, popoversStackOrders = _ref.popoversStackOrders, stackOrder = _ref.stackOrder, stickyControl = _ref.stickyControl;
  return (0, import_styled_components.css)(["background-color:", ";box-shadow:0px 1px rgba(0,0,0,0.1);box-sizing:border-box;display:flex;left:0;top:0;z-index:", ";", " & div[id^='popover']{z-index:", ";}"], darkMode ? theme.colors.black : theme.colors.beige[60], stackOrder, setSticky(stickyControl), popoversStackOrders);
});
var StyledTitleContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledTitleContainer",
  componentId: "sc-1a29rwt-1"
})(["align-items:center;justify-content:center;display:flex;flex-grow:1;box-sizing:border-box;overflow:hidden;"]);
var StyledLeftComponentContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledLeftComponentContainer",
  componentId: "sc-1a29rwt-2"
})(["width:max-content;"]);
var StyledRightComponentContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledRightComponentContainer",
  componentId: "sc-1a29rwt-3"
})(["width:max-content;"]);
var StyledPageTitle = (0, import_styled_components.default)(import_Heading.Heading).withConfig({
  displayName: "GlobalHeaderstyled__StyledPageTitle",
  componentId: "sc-1a29rwt-4"
})(function(_ref2) {
  var theme = _ref2.theme, darkMode = _ref2.darkMode, withTitleWrap = _ref2.withTitleWrap, titleTextAlignment = _ref2.titleTextAlignment;
  var withEllipsis = (0, import_styled_components.css)(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
  return (0, import_styled_components.css)(["line-height:1.5rem;font-size:", ";font-weight:", ";color:", ";", " ", ";"], theme.typography.sizes.medium, theme.typography.weights.regular, darkMode ? theme.colors.white : theme.colors.black, titleTextAlignment === "centre" && "text-align: center;", !withTitleWrap && withEllipsis);
});
var StyledUserToolbar = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledUserToolbar",
  componentId: "sc-1a29rwt-5"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["display:flex;gap:", ";"], theme.measurements.medium);
});
var StyledAppSelectorIconContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledAppSelectorIconContainer",
  componentId: "sc-1a29rwt-6"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["width:100%;height:66px;background-color:", ";display:flex;border:1px solid ", ";align-items:center;box-sizing:border-box;"], theme.colors.white, theme.colors.beige[140]);
});
var StyledAvatarContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledAvatarContainer",
  componentId: "sc-1a29rwt-7"
})(function() {
  return (0, import_styled_components.css)(["width:100%;"]);
});
var StyledAvatarButton = import_styled_components.default.button.withConfig({
  displayName: "GlobalHeaderstyled__StyledAvatarButton",
  componentId: "sc-1a29rwt-8"
})(["background:transparent;border:0;cursor:pointer;padding:0 16px 0 0;"]);
var StyledPagePrevButton = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "GlobalHeaderstyled__StyledPagePrevButton",
  componentId: "sc-1a29rwt-9"
})(function(_ref5) {
  var theme = _ref5.theme, darkMode = _ref5.darkMode;
  return (0, import_styled_components.css)(["margin-right:", ";cursor:pointer;", " padding:0;"], theme.measurements.large, darkMode && "i {color: ".concat(theme.colors.white, ";};"));
});
var StyledPageNextButton = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "GlobalHeaderstyled__StyledPageNextButton",
  componentId: "sc-1a29rwt-10"
})(function(_ref6) {
  var theme = _ref6.theme, darkMode = _ref6.darkMode;
  return (0, import_styled_components.css)(["margin-left:", ";cursor:pointer;", " padding:0;"], theme.measurements.large, darkMode && "i {color: ".concat(theme.colors.white, ";};"));
});
var StyledBreadcrumbComponent = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledBreadcrumbComponent",
  componentId: "sc-1a29rwt-11"
})(["align-items:center;display:flex;"]);
var StyledBreadcrumbSeparator = import_styled_components.default.div.withConfig({
  displayName: "GlobalHeaderstyled__StyledBreadcrumbSeparator",
  componentId: "sc-1a29rwt-12"
})(function(_ref7) {
  var margin = _ref7.margin, color = _ref7.color;
  return (0, import_styled_components.css)(["border-right:1px solid ", ";height:32px;margin:", ";"], color, margin);
});
var StyledSkipToContent = (0, import_styled_components.default)(import_atoms.SkipToContent).withConfig({
  displayName: "GlobalHeaderstyled__StyledSkipToContent",
  componentId: "sc-1a29rwt-13"
})(["&:focus{top:39px;", ";}"], (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["top:5px;"])));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledAppSelectorIconContainer,
  StyledAvatarButton,
  StyledAvatarContainer,
  StyledBreadcrumbComponent,
  StyledBreadcrumbSeparator,
  StyledHeader,
  StyledLeftComponentContainer,
  StyledPageNextButton,
  StyledPagePrevButton,
  StyledPageTitle,
  StyledRightComponentContainer,
  StyledSkipToContent,
  StyledTitleContainer,
  StyledUserToolbar
});
//# sourceMappingURL=GlobalHeader.styled.js.map